import { createSlice } from '@reduxjs/toolkit';
import { graphOptions } from './access-graph-options';
import elementProperties from './access-graph-properties';
import _ from 'underscore';
import userImage from '../../assets/images/nodes/Useractive.svg';
import connectedGroupImage from '../../assets/images/nodes/Groupsactive.svg';
import connectedPolicyImage from '../../assets/images/nodes/Permissionsactive.svg';
import connectedRoleImage from '../../assets/images/nodes/Rolesactive.svg';
import connectedResourceImage from '../../assets/images/nodes/Resourcesactive.svg';

const getNodeSize = id => {
  switch (id) {
    case 'UserAccount':
      return elementProperties.userNodeSize;

    case 'Group':
      return elementProperties.groupNodeSize;

    case 'Policy':
      return elementProperties.policyNodeSize;

    case 'Resource':
      return elementProperties.resourceNodeSize;

    case 'Role':
      return elementProperties.roleNodeSize;

    default:
      return 35;
  }
};

const getClusterId = (id, resourceType) => {
  switch (id) {
    case 'UserAccount':
      return 'userCluster';

    case 'Role':
      return 'roleCluster';

    case 'Group':
      return 'groupCluster';

    case 'Policy':
      return 'policyCluster';

    case 'Resource':
      return resourceType;

    default:
      return '';
  }
};

const getLevel = id => {
  switch (id) {
    case 'UserAccount':
      return 1;

    case 'Group':
      return 2;

    case 'Role':
      return 3;

    case 'Policy':
      return 4;

    case 'Resource':
      return 5;

    default:
      return 5;
  }
};

const getNodeImage = id => {
  switch (id) {
    case 'UserAccount':
      return userImage;

    case 'Group':
      return connectedGroupImage;

    case 'Role':
      return connectedRoleImage;

    case 'Policy':
      return connectedPolicyImage;

    case 'Resource':
      return connectedResourceImage;

    default:
      return 1;
  }
};

const getLabelString = labelString => {
  return `${labelString}
           `;
};

export const graphSlice = createSlice({
  name: 'graphState',
  initialState: {
    graphOptions,
    properties: elementProperties,
    allNodes: [],
    allEdges: [],
    nodes: [],
    edges: [],
    openClusterIds: [],
    dropdownValue: '90',
    filterValue: 'all',
    data: [],
    loaderStatus: false,
    errorMessage: ''
  },
  reducers: {
    getGraph: (state, action) => {
      state.data - action.payload;
      let formedNodes = [];
      let formedEdges = [];
      action.payload.forEach(graphDatum => {
        graphDatum.objects.forEach(object => {
          if (object.FROM && object.TO) {
            formedEdges.push({
              id: object.FROM.Id + object.FROM.Label + '->' + object.TO.Id + object.TO.Label,
              from: object.FROM.Id + object.FROM.Label,
              to: object.TO.Id + object.TO.Label,
              label: object.LabelName && object.LabelName.length > 10 ? getLabelString(`${object.Label.substring(0, 20)}...`) : getLabelString(object.Label),
              fullLabel: object.LabelName && getLabelString(object.Label),
              toolTipInfo: object,
              dashes: object.IsAccess === 'Un-Used' ? [10, 20] : false,
              lastAccessed: object.LastAccessedTime
            });
          } else {
            if (object.Id) {
              let label = object.LabelName.length > 20 ? `${object.LabelName.substring(0, 20)}...` : object.LabelName;
              formedNodes.push({
                shape: 'circularImage',
                image: getNodeImage(object.Label),
                id: object.Id + object.Label,
                label,
                size: getNodeSize(object.Label),
                type: object.Label,
                level: getLevel(object.Label),
                clusterId: getClusterId(object.Label, object.ResourceType),
                toolTipInfo: object,
                lastAccessed: object.LastAccessedTime,
                fullLabel: object.LabelName && object.LabelName
              });
            }
          }
        });
      });
      state.nodes = _.uniq(formedNodes, 'id');
      state.edges = _.uniq(formedEdges, 'id');
      state.loaderStatus = false;
    },
    pushOpenedCluster: (state, action) => {
      state.openClusterIds.push(action.payload);
    },
    pushClosedCluster: (state, action) => {
      let remainingOpenClusters = state.openClusterIds.filter(openClusterId => openClusterId !== action.payload);
      state.openClusterIds = remainingOpenClusters;
    },
    resetNodesAndEdges: state => {
      state.nodes = [];
      state.edges = [];
    },
    pushDropdownValue: (state, action) => {
      state.dropdownValue = action.payload;
    },
    pushFilterValue: (state, action) => {
      state.filterValue = action.payload;
    },
    setLoaders: (state, action) => {
      state.loaderStatus = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    }
  }
});
export const {
  getGraph,
  pushOpenedCluster,
  pushClosedCluster,
  pushBunchOpenIds,
  resetNodesAndEdges,
  pushDropdownValue,
  pushFilterValue,
  setLoaders,
  setErrorMessage
} = graphSlice.actions;
export default graphSlice.reducer;